function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3.625C4.78906 3.625 4.625 3.78906 4.625 4V13C4.625 13.2109 4.78906 13.375 5 13.375H11C11.2109 13.375 11.375 13.2109 11.375 13V7.375H9.3125C8.375 7.375 7.625 6.625 7.625 5.6875V3.625H5ZM8.75 4.09375V5.6875C8.75 5.99219 9.00781 6.25 9.3125 6.25H10.9062L8.75 4.09375ZM5 2.5H8.14062C8.53906 2.5 8.91406 2.66406 9.19531 2.94531L12.0547 5.80469C12.3359 6.08594 12.5 6.48438 12.5 6.88281V13C12.5 13.8203 11.8203 14.5 11 14.5H5C4.17969 14.5 3.5 13.8203 3.5 13V4C3.5 3.17969 4.17969 2.5 5 2.5ZM6.3125 8.5H9.6875C9.99219 8.5 10.25 8.75781 10.25 9.0625C10.25 9.36719 9.99219 9.625 9.6875 9.625H6.3125C6.00781 9.625 5.75 9.36719 5.75 9.0625C5.75 8.75781 6.00781 8.5 6.3125 8.5ZM6.3125 10.75H9.6875C9.99219 10.75 10.25 11.0078 10.25 11.3125C10.25 11.6172 9.99219 11.875 9.6875 11.875H6.3125C6.00781 11.875 5.75 11.6172 5.75 11.3125C5.75 11.0078 6.00781 10.75 6.3125 10.75Z",
  fill: "#636766"
});

function SvgPoliciesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliciesIcon);
export default __webpack_public_path__ + "static/media/policies-icon.011ba16d.svg";
export { ForwardRef as ReactComponent };